import { StaticImageData } from 'next/image'

export const getCDNSrc = (imageData: unknown): string => {
  return (imageData as unknown as StaticImageData).src
}
